import Avatar from '@mui/material/Avatar';
import AppBar from '@mui/material/AppBar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as yup from 'yup';
import _ from '@lodash';
import { yupResolver } from '@hookform/resolvers/yup';
import { forwardRef, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserById  } from 'app/store/contactsSlice';
import { selectChannel, selectChannelManageUser, setChannelManageUser, adminUpdateRole } from 'app/store/channelsSlice';
import { selectIsLoading, startLoading, stopLoading} from 'app/store/utilSlice';
import { useForm } from 'react-hook-form';
import ControlledSingleSelect from 'app/shared-components/form/ControlledSingleSelect';
import channelRoles from 'app/shared-components/controls/channelRoles.json';
import dispatchSubmit from 'app/shared-components/util/dispatchSubmit';
import history from '@history';
import DefaultButton from '../layout/DefaultButton';
import { apiGet, apiPut, apiDel, apiPost } from 'app/shared-components/util/restAPI';


const schema = yup.object().shape({
  role: yup.string().required(),
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ChannelRoleDialog(props) {
  const dispatch = useDispatch();  
  const data = useSelector(selectChannelManageUser);
  const { channelId, userId } = data;
  const [ channelMember, setChannelMember] = useState(null);
  const user = useSelector(selectUserById(userId));
  const channel = useSelector(selectChannel(channelId));
  const permissions= channel ? channel.callerPermissions : null;
  const title = 'Manage User in ' + channel?.name;
  const useRoles= permissions?.owner ? channelRoles : channelRoles.filter((role) => {return (role.value != 'admin' && role.value != 'owner')});
  
  const { handleSubmit, formState, control, reset } = useForm({
    mode: 'onChange',
    defaultValues: {
      role: '',
    },
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;


  useEffect(() => {
    if (channelId && userId) fetchChannelMember();
  }, [channelId, userId]);
  
  async function fetchChannelMember(){
    dispatch(startLoading());
    try{
      const apiName = 'CoreAPI';
  	  const path = '/channel/' + channelId + '/channelmember/' + userId;
      const options = {
  		  headers: {},
  		  response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
  	  };
  	  
  	   //Get channel member data
  	   const member= await apiGet(apiName, path, options);
  	   reset({ role: member.memberRole });
  	   setChannelMember(member);
    }finally{
      dispatch(stopLoading());
    }
  }
   
  

  function handleCloseDialog() {
    
  }

  function handleDiscard() {
	  dispatch(setChannelManageUser({}));
	  setChannelMember(null);
  }

  function onSubmit(data) {
  		dispatchSubmit({dispatch: dispatch, 
      	             submitFunction: adminUpdateRole({channelId: channelId, userId: userId, role: data.role, oldRole: channelMember.memberRole}), 
      	             onSuccess: handleDiscard,
      	             successMessage:  "Role Updated!"});
  }
  

  return (
    <Dialog
      classes={{
        paper: 'w-full m-24',
      }}
      TransitionComponent={Transition}
      onClose={handleCloseDialog}
      open={Boolean(channelMember)}
    >
      <AppBar position="static" color="secondary" elevation={0}>
	      <Toolbar className="flex w-full">
	        <Typography variant="subtitle1" color="inherit">
	          {title}
	        </Typography>
	      </Toolbar>
	  </AppBar>
	  
      <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
            <Card className="mb-32">
              <CardHeader
                className="px-32 pt-24"
                avatar={<Avatar src={user?.profileImageUrl} />}
                title={
                  <span className="flex items-center space-x-8">
                    <Typography className="font-normal" color="secondary.main" paragraph={false}>
                      {user?.firstName + " " + user?.lastName}
                    </Typography>
                  </span>
                }
                
              />

              <CardContent className="px-32">
				         <ControlledSingleSelect 
				                        name="role" label="Role"
                                control={control} errors={errors}
                                items={useRoles} />
	  
	             </CardContent>
	        </Card>
          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">
            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
			        <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Submit"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
    </Dialog>
  );
}

export default ChannelRoleDialog;
